export const OAUTH_PARAMS = {
  CLIENT_ID: 'client_id',
  REDIRECT_URI: 'redirect_uri',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  STATE: 'state',
  LOCALE: 'locale',
} as const;

export const PKCE_METHODS = {
  S256: 'S256',
} as const;

// PAIRED CONSTANT — must match the backend seed in
//   code/golden_brick/src/infra/sql/migrations/versions/*seed_narrow_gate*.py
//   code/golden_brick/src/infra/mock/account/repository/mock_client_repository.py
// Used as fallback when /login is reached without ?client_id (the first-party
// "account management center" path), so both flows share the same
// identity→authorize CSRF chain. The redirect_uri is a URN sentinel because
// first-party login never redirects, but SearchClientUseCase still enforces
// exact string equality.
export const FIRST_PARTY_CLIENT_ID = 'narrow_gate';
export const FIRST_PARTY_REDIRECT_URI = 'urn:cgm:narrow_gate:first_party';
